import { HiCheckCircle } from "react-icons/hi2";
import niosHeroBg from "../assets/nioshero.png";
import niosLogo from "../assets/National Curriculum.png";

const highlights = [
  "Recognized board accepted for higher education and competitive exams in India.",
  "Flexible subject choices and exam planning for diverse learner goals.",
  "Suitable for students balancing academics with sports, arts, travel, or coaching.",
  "Structured support through live classes, assessments, and mentoring at Altus.",
];

const pathways = [
  {
    title: "OBE (Grade 3rd, 5th, 8th)",
    text: "Build foundational learning at key levels with a flexible format designed for young learners.",
  },
  {
    title: "Secondary (Grade 9th and 10th)",
    text: "Build core academic foundations with flexible scheduling and board-aligned preparation.",
  },
  {
    title: "Senior Secondary (Grade 11th and 12th)",
    text: "Choose stream-based subjects and prepare for university admissions and entrance pathways.",
  },
];

function AboutNIOS() {
  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${niosHeroBg})` }}
        aria-labelledby="about-nios-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="about-nios-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            About NIOS
          </h1>
        </div>
      </section>

      <section
        className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
        aria-labelledby="about-nios-heading"
      >
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent"
          aria-hidden
        />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
              NIOS pathway
            </p>
            <h2
              id="about-nios-heading"
              className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:mt-5 sm:text-4xl"
            >
              Flexible, recognized schooling pathway
            </h2>

            <figure className="mt-6 flex justify-center sm:mt-8">
              <img
                src={niosLogo}
                alt="NIOS National Institute of Open Schooling"
                className="h-28 w-auto max-w-[200px] object-contain object-center sm:h-32 sm:max-w-[220px] md:h-36"
                width={220}
                height={320}
                loading="lazy"
                decoding="async"
              />
            </figure>

            <p className="mt-6 text-pretty text-base leading-relaxed text-ink/70 sm:mt-8 sm:text-lg">
              NIOS (National Institute of Open Schooling) offers a credible and
              flexible academic route for learners who need adaptable schedules
              without compromising future opportunities.
            </p>
          </div>

          <div className="mt-10 grid gap-6 md:grid-cols-2">
            {highlights.map((item) => (
              <article
                key={item}
                className="flex gap-3 rounded-2xl border border-brand/10 bg-white p-5 shadow-[0_14px_34px_-24px_rgba(30,22,51,0.2)] ring-1 ring-brand/5"
              >
                <HiCheckCircle
                  className="mt-0.5 h-5 w-5 shrink-0 text-brand"
                  aria-hidden
                />
                <p className="text-sm leading-relaxed text-ink/75 sm:text-base">
                  {item}
                </p>
              </article>
            ))}
          </div>

          <div className="mt-12 grid gap-6 lg:grid-cols-3">
            {pathways.map((item) => (
              <article
                key={item.title}
                className="rounded-2xl border border-brand/10 bg-brand-light/25 p-6 ring-1 ring-brand/5"
              >
                <h3 className="text-lg font-semibold text-ink">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink/70 sm:text-base">
                  {item.text}
                </p>
              </article>
            ))}
          </div>

          <p className="mx-auto mt-10 max-w-3xl text-center text-sm leading-relaxed text-ink/65 sm:text-base">
            Need help deciding if NIOS is right for your child? Our academic
            counsellors can help you compare pathways, subject combinations, and
            long-term goals before admission.
          </p>
        </div>
      </section>
    </div>
  );
}

export default AboutNIOS;
